/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as InviteCodeRouteImport } from './routes/invite.$code'
import { Route as AppLLoungeSlugRouteImport } from './routes/_app.l.$loungeSlug'
import { Route as AppLoungesNewRouteImport } from './routes/_app.lounges.new'
import { Route as AppSettingsInstanceRouteImport } from './routes/_app.settings.instance'
import { Route as AppSettingsProfileRouteImport } from './routes/_app.settings.profile'
import { Route as AppLLoungeSlugIndexRouteImport } from './routes/_app.l.$loungeSlug.index'
import { Route as AppLLoungeSlugInviteRouteImport } from './routes/_app.l.$loungeSlug.invite'
import { Route as AppLLoungeSlugRosterRouteImport } from './routes/_app.l.$loungeSlug.roster'
import { Route as AppLLoungeSlugSettingsRouteImport } from './routes/_app.l.$loungeSlug.settings'
import { Route as AppLLoungeSlugNNookIdRouteImport } from './routes/_app.l.$loungeSlug.n.$nookId'
import { Route as AppLLoungeSlugNooksNewRouteImport } from './routes/_app.l.$loungeSlug.nooks.new'
import { Route as AppLLoungeSlugNooksNookIdSettingsRouteImport } from './routes/_app.l.$loungeSlug.nooks.$nookId.settings'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const InviteCodeRoute = InviteCodeRouteImport.update({
  id: '/invite/$code',
  path: '/invite/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLLoungeSlugRoute = AppLLoungeSlugRouteImport.update({
  id: '/l/$loungeSlug',
  path: '/l/$loungeSlug',
  getParentRoute: () => AppRoute,
} as any)
const AppLoungesNewRoute = AppLoungesNewRouteImport.update({
  id: '/lounges/new',
  path: '/lounges/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsInstanceRoute = AppSettingsInstanceRouteImport.update({
  id: '/settings/instance',
  path: '/settings/instance',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppLLoungeSlugIndexRoute = AppLLoungeSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLLoungeSlugRoute,
} as any)
const AppLLoungeSlugInviteRoute = AppLLoungeSlugInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => AppLLoungeSlugRoute,
} as any)
const AppLLoungeSlugRosterRoute = AppLLoungeSlugRosterRouteImport.update({
  id: '/roster',
  path: '/roster',
  getParentRoute: () => AppLLoungeSlugRoute,
} as any)
const AppLLoungeSlugSettingsRoute = AppLLoungeSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppLLoungeSlugRoute,
} as any)
const AppLLoungeSlugNNookIdRoute = AppLLoungeSlugNNookIdRouteImport.update({
  id: '/n/$nookId',
  path: '/n/$nookId',
  getParentRoute: () => AppLLoungeSlugRoute,
} as any)
const AppLLoungeSlugNooksNewRoute = AppLLoungeSlugNooksNewRouteImport.update({
  id: '/nooks/new',
  path: '/nooks/new',
  getParentRoute: () => AppLLoungeSlugRoute,
} as any)
const AppLLoungeSlugNooksNookIdSettingsRoute =
  AppLLoungeSlugNooksNookIdSettingsRouteImport.update({
    id: '/nooks/$nookId/settings',
    path: '/nooks/$nookId/settings',
    getParentRoute: () => AppLLoungeSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/invite/$code': typeof InviteCodeRoute
  '/l/$loungeSlug': typeof AppLLoungeSlugRouteWithChildren
  '/lounges/new': typeof AppLoungesNewRoute
  '/settings/instance': typeof AppSettingsInstanceRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/l/$loungeSlug/invite': typeof AppLLoungeSlugInviteRoute
  '/l/$loungeSlug/roster': typeof AppLLoungeSlugRosterRoute
  '/l/$loungeSlug/settings': typeof AppLLoungeSlugSettingsRoute
  '/l/$loungeSlug/': typeof AppLLoungeSlugIndexRoute
  '/l/$loungeSlug/n/$nookId': typeof AppLLoungeSlugNNookIdRoute
  '/l/$loungeSlug/nooks/new': typeof AppLLoungeSlugNooksNewRoute
  '/l/$loungeSlug/nooks/$nookId/settings': typeof AppLLoungeSlugNooksNookIdSettingsRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/invite/$code': typeof InviteCodeRoute
  '/': typeof AppIndexRoute
  '/lounges/new': typeof AppLoungesNewRoute
  '/settings/instance': typeof AppSettingsInstanceRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/l/$loungeSlug/invite': typeof AppLLoungeSlugInviteRoute
  '/l/$loungeSlug/roster': typeof AppLLoungeSlugRosterRoute
  '/l/$loungeSlug/settings': typeof AppLLoungeSlugSettingsRoute
  '/l/$loungeSlug': typeof AppLLoungeSlugIndexRoute
  '/l/$loungeSlug/n/$nookId': typeof AppLLoungeSlugNNookIdRoute
  '/l/$loungeSlug/nooks/new': typeof AppLLoungeSlugNooksNewRoute
  '/l/$loungeSlug/nooks/$nookId/settings': typeof AppLLoungeSlugNooksNookIdSettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/invite/$code': typeof InviteCodeRoute
  '/_app/': typeof AppIndexRoute
  '/_app/l/$loungeSlug': typeof AppLLoungeSlugRouteWithChildren
  '/_app/lounges/new': typeof AppLoungesNewRoute
  '/_app/settings/instance': typeof AppSettingsInstanceRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/l/$loungeSlug/invite': typeof AppLLoungeSlugInviteRoute
  '/_app/l/$loungeSlug/roster': typeof AppLLoungeSlugRosterRoute
  '/_app/l/$loungeSlug/settings': typeof AppLLoungeSlugSettingsRoute
  '/_app/l/$loungeSlug/': typeof AppLLoungeSlugIndexRoute
  '/_app/l/$loungeSlug/n/$nookId': typeof AppLLoungeSlugNNookIdRoute
  '/_app/l/$loungeSlug/nooks/new': typeof AppLLoungeSlugNooksNewRoute
  '/_app/l/$loungeSlug/nooks/$nookId/settings': typeof AppLLoungeSlugNooksNookIdSettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/invite/$code'
    | '/l/$loungeSlug'
    | '/lounges/new'
    | '/settings/instance'
    | '/settings/profile'
    | '/l/$loungeSlug/invite'
    | '/l/$loungeSlug/roster'
    | '/l/$loungeSlug/settings'
    | '/l/$loungeSlug/'
    | '/l/$loungeSlug/n/$nookId'
    | '/l/$loungeSlug/nooks/new'
    | '/l/$loungeSlug/nooks/$nookId/settings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/invite/$code'
    | '/'
    | '/lounges/new'
    | '/settings/instance'
    | '/settings/profile'
    | '/l/$loungeSlug/invite'
    | '/l/$loungeSlug/roster'
    | '/l/$loungeSlug/settings'
    | '/l/$loungeSlug'
    | '/l/$loungeSlug/n/$nookId'
    | '/l/$loungeSlug/nooks/new'
    | '/l/$loungeSlug/nooks/$nookId/settings'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/register'
    | '/invite/$code'
    | '/_app/'
    | '/_app/l/$loungeSlug'
    | '/_app/lounges/new'
    | '/_app/settings/instance'
    | '/_app/settings/profile'
    | '/_app/l/$loungeSlug/invite'
    | '/_app/l/$loungeSlug/roster'
    | '/_app/l/$loungeSlug/settings'
    | '/_app/l/$loungeSlug/'
    | '/_app/l/$loungeSlug/n/$nookId'
    | '/_app/l/$loungeSlug/nooks/new'
    | '/_app/l/$loungeSlug/nooks/$nookId/settings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  InviteCodeRoute: typeof InviteCodeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$code': {
      id: '/invite/$code'
      path: '/invite/$code'
      fullPath: '/invite/$code'
      preLoaderRoute: typeof InviteCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/l/$loungeSlug': {
      id: '/_app/l/$loungeSlug'
      path: '/l/$loungeSlug'
      fullPath: '/l/$loungeSlug'
      preLoaderRoute: typeof AppLLoungeSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/lounges/new': {
      id: '/_app/lounges/new'
      path: '/lounges/new'
      fullPath: '/lounges/new'
      preLoaderRoute: typeof AppLoungesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/instance': {
      id: '/_app/settings/instance'
      path: '/settings/instance'
      fullPath: '/settings/instance'
      preLoaderRoute: typeof AppSettingsInstanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/l/$loungeSlug/': {
      id: '/_app/l/$loungeSlug/'
      path: '/'
      fullPath: '/l/$loungeSlug/'
      preLoaderRoute: typeof AppLLoungeSlugIndexRouteImport
      parentRoute: typeof AppLLoungeSlugRoute
    }
    '/_app/l/$loungeSlug/invite': {
      id: '/_app/l/$loungeSlug/invite'
      path: '/invite'
      fullPath: '/l/$loungeSlug/invite'
      preLoaderRoute: typeof AppLLoungeSlugInviteRouteImport
      parentRoute: typeof AppLLoungeSlugRoute
    }
    '/_app/l/$loungeSlug/roster': {
      id: '/_app/l/$loungeSlug/roster'
      path: '/roster'
      fullPath: '/l/$loungeSlug/roster'
      preLoaderRoute: typeof AppLLoungeSlugRosterRouteImport
      parentRoute: typeof AppLLoungeSlugRoute
    }
    '/_app/l/$loungeSlug/settings': {
      id: '/_app/l/$loungeSlug/settings'
      path: '/settings'
      fullPath: '/l/$loungeSlug/settings'
      preLoaderRoute: typeof AppLLoungeSlugSettingsRouteImport
      parentRoute: typeof AppLLoungeSlugRoute
    }
    '/_app/l/$loungeSlug/n/$nookId': {
      id: '/_app/l/$loungeSlug/n/$nookId'
      path: '/n/$nookId'
      fullPath: '/l/$loungeSlug/n/$nookId'
      preLoaderRoute: typeof AppLLoungeSlugNNookIdRouteImport
      parentRoute: typeof AppLLoungeSlugRoute
    }
    '/_app/l/$loungeSlug/nooks/new': {
      id: '/_app/l/$loungeSlug/nooks/new'
      path: '/nooks/new'
      fullPath: '/l/$loungeSlug/nooks/new'
      preLoaderRoute: typeof AppLLoungeSlugNooksNewRouteImport
      parentRoute: typeof AppLLoungeSlugRoute
    }
    '/_app/l/$loungeSlug/nooks/$nookId/settings': {
      id: '/_app/l/$loungeSlug/nooks/$nookId/settings'
      path: '/nooks/$nookId/settings'
      fullPath: '/l/$loungeSlug/nooks/$nookId/settings'
      preLoaderRoute: typeof AppLLoungeSlugNooksNookIdSettingsRouteImport
      parentRoute: typeof AppLLoungeSlugRoute
    }
  }
}

interface AppLLoungeSlugRouteChildren {
  AppLLoungeSlugInviteRoute: typeof AppLLoungeSlugInviteRoute
  AppLLoungeSlugRosterRoute: typeof AppLLoungeSlugRosterRoute
  AppLLoungeSlugSettingsRoute: typeof AppLLoungeSlugSettingsRoute
  AppLLoungeSlugIndexRoute: typeof AppLLoungeSlugIndexRoute
  AppLLoungeSlugNNookIdRoute: typeof AppLLoungeSlugNNookIdRoute
  AppLLoungeSlugNooksNewRoute: typeof AppLLoungeSlugNooksNewRoute
  AppLLoungeSlugNooksNookIdSettingsRoute: typeof AppLLoungeSlugNooksNookIdSettingsRoute
}

const AppLLoungeSlugRouteChildren: AppLLoungeSlugRouteChildren = {
  AppLLoungeSlugInviteRoute: AppLLoungeSlugInviteRoute,
  AppLLoungeSlugRosterRoute: AppLLoungeSlugRosterRoute,
  AppLLoungeSlugSettingsRoute: AppLLoungeSlugSettingsRoute,
  AppLLoungeSlugIndexRoute: AppLLoungeSlugIndexRoute,
  AppLLoungeSlugNNookIdRoute: AppLLoungeSlugNNookIdRoute,
  AppLLoungeSlugNooksNewRoute: AppLLoungeSlugNooksNewRoute,
  AppLLoungeSlugNooksNookIdSettingsRoute:
    AppLLoungeSlugNooksNookIdSettingsRoute,
}

const AppLLoungeSlugRouteWithChildren = AppLLoungeSlugRoute._addFileChildren(
  AppLLoungeSlugRouteChildren,
)

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppLLoungeSlugRoute: typeof AppLLoungeSlugRouteWithChildren
  AppLoungesNewRoute: typeof AppLoungesNewRoute
  AppSettingsInstanceRoute: typeof AppSettingsInstanceRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppLLoungeSlugRoute: AppLLoungeSlugRouteWithChildren,
  AppLoungesNewRoute: AppLoungesNewRoute,
  AppSettingsInstanceRoute: AppSettingsInstanceRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  InviteCodeRoute: InviteCodeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
